import { useCallback } from 'react';

export const useGoToHome = (): { goToHome: () => void } => {
  const goToHome = useCallback(() => {
    window.location.assign('/');
  }, []);

  return { goToHome };
};
